let cachedBaseUrl: string | null = null;

export function resolveWidgetAssetUrl(relativePath: string): string {
  if (!relativePath) {
    return relativePath;
  }
  if (!cachedBaseUrl) {
    cachedBaseUrl = computeAssetBaseUrl();
  }
  if (!cachedBaseUrl) {
    return relativePath;
  }
  const needsSlash =
    !cachedBaseUrl.endsWith('/') && !relativePath.startsWith('/');
  return `${cachedBaseUrl}${needsSlash ? '/' : ''}${relativePath.replace(/^\/+/, '')}`;
}

function computeAssetBaseUrl(): string {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return '/assets/';
  }
  try {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const toolScript =
      scripts.find((script) => script.src?.includes('tools/browser/main')) ??
      scripts.find((script) => script.src?.includes('main.js'));
    if (toolScript?.src) {
      const url = new URL(toolScript.src, window.location.href);
      const directory = url.pathname.replace(/[^/]+$/, '');
      return `${url.origin}${directory}assets/`;
    }
  } catch {
    // ignore and use fallback
  }
  return `${window.location.origin}/assets/`;
}
